import React from 'react'
import "./disclaimer.scss";

export const Disclaimer = () => {
  return (
    <div className="policy-container disclaimer-page">
      {/* Centered Content Layout */}
      <main className="policy-content">
        <header className="policy-header">
          <div className="disclaimer-badge">Legal Disclaimer</div>
          <h1>Risk Disclosure & Disclaimer</h1>
          <p className="effective-date">
            Last Updated: <span>February 2026</span>
          </p>
        </header>

        <section className="intro-card warning">
          <p>
            <strong>Intellitech</strong> is a technology provider, not a
            financial advisor. Trading involves substantial risk. You should
            only trade with capital you can afford to lose.
          </p>
        </section>

        <article>
          <h2>1. Not a Financial Institution</h2>
          <p>
            Intellitech develops and licenses algorithmic trading software. We
            are <strong>not</strong> a registered broker-dealer, investment
            adviser, or fund manager We do not hold custody of client assets or manage
            brokerage accounts.
          </p>
        </article>

        <article>
          <h2>2. Hypothetical Performance Disclosure</h2>
          <p>
            The software and any associated tools are provided for{" "}
            <strong>informational and educational purposes only</strong>. All
            trading signals, backtests, and simulations are generated by
            algorithms and based on historical data.
          </p>
          <div className="hypothetical-box">
            <p>
              Results are hypothetical in nature and do not represent actual
              trading. They do not account for:
            </p>
            <ul>
              <li>Market liquidity and slippage</li>
              <li>Broker commissions</li>
              <li>Execution delays</li>
              <li>Real-time changing market conditions</li>
            </ul>
          </div>
        </article>

        <article>
          <h2>3. No Guarantees</h2>
          <p>
            Past performance, whether actual or simulated, is{" "}
            <strong>not indicative of future results</strong>. No representation
            is being made that any account will or is likely to achieve profits
            or losses similar to those shown.
          </p>
        </article>

        <article className="prohibited-list">
          <h2>4. No Solicitation</h2>
          <p>
            Nothing on this website or within the software should be construed
            as:
          </p>
          <div className="grid-info">
            <div className="info-block">
              <p>
                An offer or recommendation to buy or sell securities or
                derivatives.
              </p>
            </div>
            <div className="info-block">
              <p>
                Personalized investment advice or a guarantee of profitability.
              </p>
            </div>
            <div className="info-block">
              <p>A promise of performance or risk-free trading.</p>
            </div>
          </div>
        </article>

        <article className="liability-statement">
          <h2>5. Limitation of Liability</h2>
          <p>
            By using our software, you acknowledge and agree that{" "}
            <strong>Intellitech</strong> and its owners, directors, and partners
            shall not be held liable for any trading losses, damages, or
            consequences resulting from the use of the software or reliance on
            provided information.
          </p>
        </article>

        <footer className="disclaimer-footer">
          <p>
            Users are solely responsible for their own trading decisions and
            compliance with local laws.
          </p>
        </footer>
      </main>
    </div>
  );
}
